import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

//Our Imports
import { CustomButton } from '../../../assets/component/initComponent';
import { imageExist }  from '../../../assets/js/init';
import useInView from '../../../hooks/useInView';

const AllInOne = ({ scrollToSection }) => {

	const theme    = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md')); 

	//InView Hook
	const [sectionRef, inView] = useInView();

	const secAImg = [
		'secA1',
		'secA2',
		'secA3',
		'secA4',
		'secA5',
		'secA6',
		'secA7'
	];

	const secBImg = [
		{ title: 'SIP Calculator', img: 'secB1' },
		{ title: 'Lumpsum Calculator', img: 'secB2' },
		{ title: 'Exit Load Calculator', img: 'secB3' },
		{ title: 'Step-up SIP Calculator', img: 'secB4' },
		{ title: 'Capital Gain Calculator', img: 'secB5' },
		{ title: 'SWP Calculator', img: 'secB6' },
		{ title: 'XIRR Calculator', img: 'secB7' },
		{ title: 'CAGR Calculator', img: 'secB8' }
	];

	const secCImg = [
		'secC1',
		'secC2',
		'secC3',
		'secC4',
		'secC5',
		'secC6',
		'secC7',
		'secC8'
	];

	// Parent controls the timing (stagger)
	const containerVariant = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.2   // delay between cards
			}
		}
	};

	// Each card animation
	const cardVariant = {
		hidden: {
			opacity: 0
			// y: 100
			// scale: 0.90
		},
		visible: {
			opacity: 1,
			// y: 0,
			// scale: 1,
			transition: {
				duration: 1,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	// const [enter, setEnter] = useState(false);
	const [startAni, setStartAni] = useState(false);

	// const handleEnter = (from) => {
	// 	// if (from === 'enter') {
	// 	// 	setEnter(true);
	// 	// } else {
	// 	// 	setEnter(false);
	// 	// }
	// };

	useEffect(() => {
		if (inView) {
			setStartAni(true);
		} else {
			setStartAni(false);
		}
	}, [inView]);

	const radiusA = isMobile ? 175 : 275;
	const radiusB = 420;
	const radiusC = 575;

	return(
		<Container className="containerFull" sx={{ overflow: 'hidden' }}>
			<Grid ref={sectionRef} container justifyContent='center' alignItems='center' py={{ md: 5, xs: 3 }}>
				<Box className={`aioBoxC ${startAni && 'aioBoxCActive'}`} >
					{/* onMouseEnter={() => handleEnter('enter')} onMouseLeave={handleEnter} */}
					{secCImg.map((img, index) => {
						const angle = (360 / secCImg.length) * index;
						return (
							<Box key={index} className="orbitItem"
								sx={{ transform: `translate(-50%, -50%) rotate(${angle}deg) translate(${radiusC}px) rotate(-${angle}deg)`,  backdropFilter: 'blur(2px)', display: { md: 'block', xs: 'none' } }}
							>
								{imageExist({
									required: '/allInOne',
									url: `/${img}.svg`,
									alt: 'all',
									height: '35px'
								})}
							</Box>
						);
					})}
					<Box className={`aioBoxB ${startAni && 'aioBoxBActive'}`}>
						<Box className="orbitRing">
							{secBImg.map((list, index) => {
								const angle = (360 / secBImg.length) * index;
								return (
									<Box key={index} className="orbitItemB"
										sx={{ transform: `translate(-50%, -50%) rotate(${angle}deg) translate(${radiusB}px) rotate(-${angle}deg)`, display: { md: 'block', xs: 'none' } }}
									>
										<Stack alignItems='center'>
											{imageExist({
												required: '/allInOne',
												url: `/${list.img}.svg`,
												alt: 'all',
												height: '50px'
											})}
											<Typography className='font13' sx={{ whiteSpace: 'nowrap' }}>{list.title}</Typography>
										</Stack>
									</Box>
								);
							})}
						</Box>
						<Box className="orbitStage">
							{/* INNER ORBIT */}
							<motion.div
								variants={containerVariant}
								initial='hidden'
								// animate={controls}
								whileInView='visible'
								viewport={{ once: false }}
							>
								<Box className="orbitRing orbitA">
									{secAImg.map((img, index) => {
										const angle = (360 / secAImg.length) * index;
										return (
											<motion.div
												key={index}
												variants={cardVariant}
												// whileHover={{ y: -8 }}
												transition={{ type: 'spring', stiffness: 200, damping: 18 }}
												style={{ height: '100%' }}
											>
												<Box
													key={index}
													className="orbitItem"
													sx={{ transform: `translate(-50%, -50%) rotate(${angle}deg) translate(${radiusA}px) rotate(-${angle}deg)` }}
												>
													<Box className="orbitIcon">
														{imageExist({
															required: '/allInOne',
															url: `/${img}.svg`,
															alt: 'all',
															height: '35px'
														})}
													</Box>
												</Box>
											</motion.div>
										);
									})}
								</Box>
							</motion.div>

							{/* CENTER CONTENT */}
							<Stack spacing={1} className="orbitCenter" alignItems="center" justifyContent="center">
								<Typography className={`${isMobile ? 'font16' : 'font25'} txtCenter`}>All-In-One App For <br/> <span className="fontBold font30">Financial Calculator</span></Typography>
								<Grid size={{ md: 7.5, xs: 8 }}>
									<CustomButton onClick={(e) => scrollToSection(e, '#demo')}>{isMobile ? 'View Demo' : 'Explore Our Demo'}</CustomButton>
								</Grid>
							</Stack>
						</Box>
					</Box>
				</Box>
			</Grid>
		</Container>
	);
};

export default AllInOne;
